export default {
  SITENAME: 'Corgiville Museum',
  COPYRIGHT: '&copy;Corgiville Museum ALL RIGHTS RESERVED.',
  HOME: {
    MAINVISUAL: 'Corgiville Museum',
    SUBTEXT:
      '<p>アメリカの35代大統領、ジョン・フィツジェラルド・ケネディは大統領就任時43歳。一回り年下のジャクリーン夫人と共には、若く強く美しいアメリカの象徴であり、時にスキャンダラスな人間的魅力を放ってさえいた。 1963年11月22日、テキサス州ダラスを遊説中に銃弾によって、その大統領生命も一人の人間としての人生も突然、終止符を打たれることになる。残された妻ジャッキーことジャクリーンは、一私人となったその後もマスコミに追われ続ける運命となった。</p><p>また、これほど多くのビジュアルに登場した大統領夫婦も過去にいなかったと言えるだろう。このCorgiville Museumは、数多くのアイテムになったケネディとジャクリーンを公開するサイトである。<br>時が経ても決して色褪せることなく、私たちの心を捉えて離さない。今一度JFKとジャッキーへ捧げる─”You are not gone from us.”</p>',
    TITLE01: 'Infomation',
    TITLE02: 'New Exhibition',
    MORE: '展示室へ入る',
    SHOP: 'ミュージアムショップへ',
  },
  EXHIBITION: {
    TITLE: '展示室',
    ex01: {
      TITLE: '第1展示室 JFKの胸像',
      TEXT:
        'JFKの妻、ジャクリーンは、あるとき夫のことを「ジャックは幻想を持たない理想主義者」と評した。その言葉を象徴するかのような様々な胸像がここに集合。',
    },
    ex02: {
      TITLE: '第2展示室 ロッキングチェアーと大統領',
      TEXT:
        '1954年に脊椎手術を受けたケネディは終生、背骨の疾患から解放されることはなかったが、主治医の勧めで苦痛を和らげるためにロッキングチェアーを愛用するようになった。',
    },
    ex03: {
      TITLE: '第3展示室 レコード・ビデオ・映画ポスターなど',
      TEXT:
        'ケネディは大統領選で初めてテレビというメディアを使った大統領。それだけに、演説をおさめたレコード、暗殺をテーマにした映画やビデオ、はたまた宝塚歌劇にまで登場。その類まれなタレント性が伺える。',
    },
    ex04: {
      TITLE: '第4展示室 トランプ・ゲーム・クイズ盤など',
      TEXT:
        '在職中に発売されたトランプやゲーム、死後40年たっても売られているジグゾーパズル、定規や指貫き、ランチョンマットまでとにかく楽しいアイテム',
    },
    ex05: {
      TITLE: '第5展示室 絵皿・タピストリーなど',
      TEXT:
        '絵皿もかなり、多く作られている。同じ運命をたどった弟ロバートとのショットも多い。made　in　Italyのタピストリーは一見似たような40種類以上の絵柄があり、専門のコレクターもいるとか',
    },
    ex06: {
      TITLE: '第6展示室 キャンペーングッズ・大統領就任記念ものなど',
      TEXT:
        '1960年の大統領選でケネディ陣営は、テレビ討論、妹たちによるティーパーティーなど華やかなキャンペーンで大衆の心を掴んだ。バッジ、シール、お面、帽子などのキャンペーングッズが今に残る',
    },
    ex07: {
      TITLE: '第7展示室 肖像画・レリーフなど',
      TEXT:
        '大統領の任期半ばで凶弾に倒れた大統領。非業の死を遂げたにもかかわらず、私たちに残された笑顔は一点のくもりもない青空のように爽やか',
    },
    ex08: {
      TITLE: '第8展示室 Tシャツ・ジッポ・懐中時計・ペンダントなど',
      TEXT:
        '"裏原宿”の若者向けの洋服屋さんにかかっていたTシャツ、札幌のすすき野のアーケード街で売っていたペンダント‥‥　デッドストックあり、新品あり。時は流れて21世紀になっても絵になる大統領',
    },
    ex09: {
      TITLE: '第9展示室 ジャッキー・ワールド',
      TEXT:
        '"Fey”には「妖精が見える能力」と「死にとり憑かれた」という異なった意味合いがあるそうで(キティ・ケリー著、岡本　浜江訳「ジャッキー、Oh」より）、ジャクリーン・ケネディ・オナシスという女性の人生、人となりをこれほど端的に表現した言葉を他に知らない',
    },
    ex10: {
      TITLE: '第10展示室 記念メダル・豆本・紙幣など',
      TEXT:
        '集め切れないほど種類のある記念メダルや意匠を凝らした豆本、ユニークなところではパロディ1ドル紙幣や軍票など掌にのるコレクションアイテム',
    },
    ex11: {
      TITLE: '第11展示室 世界のケネディマニアコレクション',
      TEXT: '',
    },
    ex12: {
      TITLE: '第12展示室 ケネディ夫妻のツーショットアイテム',
      TEXT:
        '女の子なら誰でも物語の中の「二人」に恋することがあるだろう。「嵐が丘」のキャサリンとヒースクリフだったり、「風と共に去りぬ」のスカーレットとレットだったり‥‥私の中では、それが「ジャックとジャッキー」の世界だった。',
    },
    FEYGIRL: {
      TITLE: '刺繍で綴るジャクリーン・ケネディの一生',
      TEXT:
        '長年、ケネディとジャッキーのアイテムをコレクションして、次に考えたのがオリジナルな作品作りだった。コレクションのきっかけはジャッキーで、この20世紀に生きた稀有な女性に尽きない興味があった。そこで、彼女の一生を刺繍で描いてみようと思い立ったのである。波乱に富んだジャッキーの人生の限られたシーンを選び出すことは至難の業だったが、まず第1弾として15のライフシーンとテーマから描いた4点をお送りしたいと思う。この企画展の図録も作成し、その中にタイトルを「Fey Girl」とした理由が書かれている。',
    },
  },
  SPECIALEXHIBITION: {
    TITLE: '特別展示室',
  },
  GREETING: {
    TITLE: '館長ご挨拶',
    TEXT:
      '<p>「Corgiville Museum」へようこそ！</p><p>このささやかなWEBミュージアムは、私が長年収集してきたケネディ関係のアイテムを公開したものです。私のコレクションは、胸像、人形、メダル、プレート、本、雑誌、キャンペーングッズ、ファッション雑貨からとんでもないガラクタまでジャンルを問いません。</p><p>小学生の頃、雑誌で「ジャクリーン・ケネディ夫人伝」という連載を読んでから、ジャクリーン・ケネディ（愛称・ジャッキー）という女性に強く惹かれるようになりました。<br>彼女は他の誰とも似ていません。その容姿、ふるまい、ファッション、趣味、生き方、そして何よりその運命においても。</p><p>連載のあった当時は、ケネディ暗殺から何年かたった頃で、まだあの大富豪のオナシスとは再婚してなかったので、二児をを抱えて健気に夫の思い出と共に生きる未亡人として、世界がジャッキーに好意的だった時期ということもあったのでしょう。<br>その物語には、ジャッキーの生い立ち、大好きな父との別れ、ジョン・ケネディとの出会い、苦難を乗り越えて掴んだファーストレディへの道のり、夫の暗殺、そして未亡人として生きる日々までがたいへん魅力的に書かれていました。<br>後になっていろいろな本を読むと、けっして一筋縄ではいかなかったケネディとジャクリーンの関係も、そこではロマンチックな「ジャックとジャッキー」のラブストーリーとして描かれており、私は夢中になって、何回も何回も暗記するほどに読んだものです。<br>少女時代、誰もが「風と共に去りぬ」のスカーレットとレットや「嵐が丘」のキャサリンとヒースクリフのロマンスに熱中するものですが、私にとってはそれがジャッキーとジャックの世界だったのかもしれません。</p><p>いろいろなものをコレクションするようになったのは、渋谷のアンティークショップで、偶然、ケネディのお面をみつけてからです。<br>まだ、何でもネットオークションで手に入る時代ではなかったので、「偶然の出会い」にわくわくして、収集していきました。</p><p></p>当ミュージアムは12の展示室に分かれております。どうぞ、お好きな部屋から覗いてみてください。<br>私のコレクションを通じて、多少でもケネディ大統領やジャクリーン夫人のいた時代の息吹を感じていただければ嬉しく思います</p>',
    TITLE2: '私のコレクション第1号はこのソノシート',
    TEXT2:
      '<p><b>館長　紅木 美る（コウギ ビル）</b></p><p>東京都世田谷区出身。<br />12歳の時、「ジャクリーン・ケネディ」の物語を読んで以来、ジャッキーやケネディ家に関心を持つようになり、彼らの肖像を使ったあらゆるジャンルのものをコレクションしている。</p>',
    TEXT3:
      '<p>「ジャクリーン・ケネディ夫人伝」は「女学生の友」という雑誌に5回にわたって連載されたのですが、その最終回に付録としてついていたのが、1枚の赤いそのシートでした。「世界のトップレディの声」というタイトルで、当時の皇太子妃美智子様とジャクリーン・ケネディの話を吹き込んだもので、ジャッキーの生の声に感激したのを覚えています。偶然にも、私のケネディコレクションの一番古いものとなりました。</p>',
    TITLE3: 'メディア紹介実績',
    TEXT4:
      '<li><span class="topicsDate">2008.7.5</span>放映関西テレビローカル「LOVE偉人伝」</li><li><span class="topicsDate">2011.5.19</span>放映やじうまテレビ「きょう発あの日あの時」</li>',
  },
  MUSEUMINFO: {
    TITLE: '館内ご案内',
    TEXT: 'Corgiville Museumの館内をご紹介します。',
    TEXT2:
      '<p><b>特定商取引に関する法律に基づく表記</b></p><p>販売業者:　nonna giglio（ノンナ　ジュリオ）</p><p>古物商許可:　東京都公安委員会第303321905896号</p><p>運営責任者:　古跡　ゆり</p><p>住所:　東京都渋谷区神宮前5-21-3</p><p>メールアドレス:　mail@nonna-giglio.com</p><p>URL:　https://www.nonna-giglio.com</p>',
  },
  MUSEUMSHOP: {
    TITLE: 'Museum Shop',
    TEXT: 'Corgiville Museumのミュージアムショップです。',
    BUTTONTEXT: 'mail@nonna-giglio.com',
  },
  LINK: {
    TITLE: 'Link',
    TEXT: '<p><b>ケネディに関するリンク集です。</b></p>',
  },
  RESTROOM: {
    TITLE: 'お化粧室',
    TEXT: '<p><b>Corgiville Museumのお化粧室です。</b></p>',
  },
  CONTACT: {
    TEXT: '当館へのお問い合わせはこちら',
  }
}
